import { ROUTE_PROFILE } from "Consts/publicRoutes";

export const SIDENAV_PROFILE_SECTION = {
  text: "Profile",
  userRoute: ROUTE_PROFILE,
  restrictedRoute: ROUTE_PROFILE,
};

export const SIDENAV_PROFILE_MY_ROUTE = (user) => {
  return {
    route: { name: ROUTE_PROFILE, params: { id: user.id } },
    text: "My profile",
  };
};

export const SIDENAV_PROFILE_MY_ACTIVITY = {
  route: { name: "activity.log", params: { tab: "my" } },
  text: "My activity",
};
